import useWindowPositionTop from 'hooks/useWindowPositionTop';

export default function CourseForTheOGE() {
    useWindowPositionTop();
  return (
    <>
      <style>{`
        .oge-course {
          white-space: pre-line;
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          line-height: 1.6;
          margin: 0 auto;
          padding: 8rem 2rem;
          box-sizing: border-box;
          background: #fff;
          color: #222;
          border-radius: 8px;
          transition: padding 0.3s ease;
          max-width: 720px;
        }

        .oge-course h2 {
          font-size: 2.25rem;
          font-weight: 700;
          margin-bottom: 1rem;
          color: #003366;
          line-height: 1.1;
        }

        .oge-course p {
          margin-bottom: 1.25rem;
          font-size: 1.125rem;
          font-weight: 400;
          color: #333;
        }

        .oge-course ul {
          margin-bottom: 1.75rem;
          padding-left: 1.5rem;
          list-style-type: disc;
          color: #444;
        }

        .oge-course ul li {
          margin-bottom: 0.6rem;
          font-size: 1.05rem;
          line-height: 1.4;
        }

        .oge-course ul li ul {
          list-style-type: circle;
          margin-top: 0.3rem;
          margin-bottom: 0.8rem;
          padding-left: 1.2rem;
        }

        .oge-course ul li ul li {
          font-size: 1rem;
          margin-bottom: 0.4rem;
        }

        .oge-course strong {
          font-weight: 700;
          color: #002244;
        }

        .oge-course .highlight {
          font-weight: 700;
          font-size: 1.2rem;
          color: #b22222;
          margin-top: 2rem;
        }

        /* Responsive typography and spacing */
        @media (max-width: 1024px) {
          .oge-course h2 {
            font-size: 1.9rem;
          }
          .oge-course p,
          .oge-course ul li {
            font-size: 1rem;
          }
          .oge-course ul li ul li {
            font-size: 0.95rem;
          }
        }

        @media (max-width: 600px) {
          .oge-course h2 {
            font-size: 1.6rem;
          }
          .oge-course p,
          .oge-course ul li {
            font-size: 0.95rem;
          }
          .oge-course ul {
            padding-left: 1.2rem;
          }
          .oge-course ul li ul {
            padding-left: 1rem;
          }
          .oge-course ul li ul li {
            font-size: 0.9rem;
          }
        }

        @media (max-width: 360px) {
          .oge-course h2 {
            font-size: 1.4rem;
          }
          .oge-course p,
          .oge-course ul li {
            font-size: 0.9rem;
          }
          .oge-course ul li ul li {
            font-size: 0.85rem;
          }
        }
      `}</style>

      <div className="oge-course">
        <h2>КУРС ПОДГОТОВКИ К ОГЭ</h2>
        <p>🎯 ГОТОВИМСЯ К ОГЭ ПО АНГЛИЙСКОМУ ЯЗЫКУ!</p>
        <p>
          Ваш ребёнок готовится к ОГЭ по английскому? Помогу сдать экзамен на хороший балл!
        </p>
        <p><strong>Почему этот курс — это именно то, что нужно для успешной сдачи ОГЭ:</strong></p>
        <ul>
          <li>Полная подготовка к каждому разделу экзамена</li>
          <li>Индивидуальный подход к каждому ученику</li>
          <li>Практические занятия с реальными КИМами</li>
          <li>Работа над ошибками с детальным разбором</li>
        </ul>

        <p><strong>🏆 ЧТО ВКЛЮЧАЕТ КУРС:</strong></p>
        <ul>
          <li>
            Аудирование:
            <ul>
              <li>Тренировка восприятия речи на слух</li>
              <li>Работа с типичными заданиями</li>
              <li>Секреты успешного выполнения</li>
            </ul>
          </li>
          <li>
            Грамматика и лексика:
            <ul>
              <li>Отработка всех тем ОГЭ</li>
              <li>Устранение типичных ошибок</li>
              <li>Специальные упражнения</li>
            </ul>
          </li>
          <li>
            Письменная речь:
            <ul>
              <li>Написание писем по готовому шаблону</li>
            </ul>
          </li>
          <li>
            Говорение:
            <ul>
              <li>Подготовка к устной части</li>
              <li>Тренировка произношения</li>
              <li>Работа над беглостью речи</li>
            </ul>
          </li>
        </ul>

        <p><strong>📊 РЕЗУЛЬТАТЫ, КОТОРЫЕ ВЫ ПОЛУЧИТЕ:</strong></p>
        <ul>
          <li>Уверенное выполнение всех заданий ОГЭ</li>
          <li>Понимание структуры экзамена</li>
          <li>Владение стратегиями решения заданий</li>
          <li>Повышение общего уровня языка</li>
          <li>Снижение стресса перед экзаменом</li>
        </ul>

        <p><strong>🎁 БОНУСЫ КУРСА:</strong></p>
        <ul>
          <li>Персональный план подготовки</li>
          <li>Дополнительные материалы для практики</li>
          <li>Пробные тестирования в формате ОГЭ</li>
          <li>Консультации по сложным темам</li>
          <li>Все занятия в записи</li>
        </ul>

        <p><strong>⏰ ФОРМАТ ОБУЧЕНИЯ:</strong></p>
        <ul>
          <li>Групповые занятия</li>
          <li>Индивидуальные занятия</li>
          <li>Онлайн-формат</li>
          <li>Гибкий график</li>
        </ul>

        <p><strong>Особенности формата:</strong></p>
        <ul>
          <li>Индивидуальные занятия</li>
          <li>Занятия в парах</li>
          <li>Занятия в мини-группах (до 3 человек)</li>
        </ul>

        <p><strong>СТОИМОСТЬ ЗАНЯТИЙ:</strong></p>
        <ul>
          <li>Индивидуальное занятие — 1800 р./90 минут</li>
          <li>Занятие в паре — 1200 р./90 минут</li>
          <li>Занятие в мини-группе — 1000 р./90 минут</li>
        </ul>

        <p>
          Не откладывайте подготовку к ОГЭ на последний момент!
        </p>
        <p className="highlight">
          📞 ЗАПИШИТЕСЬ НА КУРС ПРЯМО СЕЙЧАС!<br />
          Количество мест в группах ограничено!<br />
          Помогите вашему ребёнку сдать ОГЭ по английскому на высокий балл!
        </p>

        <p>#огэанглийский #подготовкакогэ #английскийязык #экзамены #образование</p>
      </div>
    </>
  );
}

